import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetProjectControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetProjectControlledPermissionsRequest
    extends Request<ISetProjectControlledPermissionsParams, IEmptyResult> {
  constructor(params: ISetProjectControlledPermissionsParams) {
    super('setProjectControlledPermissions', params);
  }
}
